var Marionette = require('marionette')
var tplSurveyOption = require('./../templates/ItemOption.html')

module.exports = Marionette.ItemView.extend({
  tagName: 'li',
  className: 'survey-item__multiselect-option',
  template: tplSurveyOption,

  events: {
    click: 'onItemOptionValueChanged'
  },

  onItemOptionValueChanged: function () {
    this.model.set('selected', !this.model.get('selected'))
    this.$el.toggleClass(
      'survey-item__multiselect-option--is-checked',
      this.model.get('selected')
    )
    this.trigger('item:option:value:changed')
  },

  templateHelpers: function () {
    return {
      itemIndex: this.getOption('itemIndex'),
      optionIndex: this.getOption('optionIndex')
    }
  }
})
